import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError, tokenStore } from "@/lib/api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=auth
  const [empresas, setEmpresas] = useState([]);
  const [empresa, setEmpresa] = useState(null);

  const loadEmpresas = useCallback(async () => {
    const { data: emps } = await api.get("/empresas");
    setEmpresas(emps);
    const stored = localStorage.getItem("active_empresa_id");
    const found = emps.find((e) => e.id === stored) || emps[0];
    if (found) {
      setEmpresa(found);
      localStorage.setItem("active_empresa_id", found.id);
    }
    return emps;
  }, []);

  const fetchMe = useCallback(async () => {
    if (!tokenStore.get()) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadEmpresas();
    } catch {
      tokenStore.clear();
      setUser(false);
    }
  }, [loadEmpresas]);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) tokenStore.set(data.access_token);
    setUser(data.user);
    await loadEmpresas();
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    if (data.access_token) tokenStore.set(data.access_token);
    setUser(data.user);
    setEmpresas([]);
    setEmpresa(null);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    tokenStore.clear();
    localStorage.removeItem("active_empresa_id");
    setUser(false);
    setEmpresa(null);
    setEmpresas([]);
  };

  const switchEmpresa = (e) => {
    setEmpresa(e);
    localStorage.setItem("active_empresa_id", e.id);
  };

  const reloadEmpresas = async () => loadEmpresas();

  return (
    <AppContext.Provider value={{ user, empresas, empresa, login, register, logout, switchEmpresa, reloadEmpresas, formatApiError }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
